<script setup>
import { ref, onMounted } from 'vue';
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import edekaLogo from '@/assets/edeka_logo.png';
import gismaLogo from '@/assets/GismaLogo.png';
import rvLogo from '@/assets/RVLogoV2.png';
import tbaLogo from '@/assets/tb&a_logo.png';
import { useScrollAnimations } from '@/composables/useScrollAnimations';

const logos = [
  { name: 'TB&A', src: tbaLogo },
  { name: 'R+V', src: rvLogo },
  { name: 'EDEKA', src: edekaLogo },
  { name: 'Gisma', src: gismaLogo },
];

const breakpoints = {
  // 700px and up
  700: {
    itemsToShow: 3,
    snapAlign: 'center',
  },
  // 1024px and up
  1024: {
    itemsToShow: 4,
    snapAlign: 'start',
  },
};

const partnersSection = ref(null);
const partnersTitle = ref(null);
const partnersCarousel = ref(null);

const { slideUp, animateInView } = useScrollAnimations();

const initScrollAnimations = () => {
  if (partnersSection.value) {
    animateInView(partnersSection.value, () => {
      slideUp(partnersTitle.value);
      slideUp(partnersCarousel.value, 0.3);
    });
  }
};

onMounted(() => {
  initScrollAnimations();
});
</script>

<template>
  <div class="py-12" ref="partnersSection">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <h2 ref="partnersTitle" class="text-left text-2xl font-bold tracking-tight text-white sm:text-3xl mb-12 opacity-0"
        v-html="$t('landingPage.v2.partners.title')">
      </h2>

      <div ref="partnersCarousel" class="opacity-0">
        <Carousel :items-to-show="1.5" :wrap-around="true" :breakpoints="breakpoints" :autoplay="3000"
          :transition="500">
          <Slide v-for="logo in logos" :key="logo.name">
            <div class="carousel__item px-8 flex items-center justify-center h-24 w-full">
              <img :src="logo.src" :alt="logo.name"
                class="max-h-32 w-auto object-contain brightness-0 invert opacity-80 hover:opacity-100 transition-opacity duration-300" />
            </div>
          </Slide>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<style scoped>
:deep(.carousel__slide) {
  padding: 10px;
}

:deep(.carousel__track) {
  align-items: center;
}
</style>
